import React, { memo, useMemo } from 'react'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import { DESTRUCTIVE_STEP_ACTIONS, stepActionTitles } from 'src/constants/partnerDriver/constants'
import { StepAction } from 'src/constants/partnerDriver/enums'
import type { PartnerDriverStep, StepActionPermissions } from 'src/interfaces/partnerDriver'
import type { MenuActionItem } from 'src/interfaces/ui'
import { getStepActions } from 'src/utils/partnerDriver/stepActions'

interface Props {
  step: PartnerDriverStep
  permissions: StepActionPermissions
  onSelectAction(step: PartnerDriverStep, action: StepAction): void
}

const StepActionsCellComponent = ({ step, permissions, onSelectAction }: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return getStepActions(step, permissions).map((action) => {
      return {
        label: stepActionTitles[action],
        color: DESTRUCTIVE_STEP_ACTIONS.includes(action) ? 'var(--mui-critical-500)' : undefined,
        dataTestId: `partner-driver-step-${step.id}-${action}`,
        onClick: () => {
          onSelectAction(step, action)
        },
      }
    })
  }, [step, permissions, onSelectAction])

  if (items.length === 0) {
    return null
  }

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="Step actions"
      dataTestId={`partner-driver-step-actions-${step.id}`}
    />
  )
}

export const StepActionsCell = memo(StepActionsCellComponent)
